import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

const CustomPagination = ({ totalPages, currentPage, handlePageChange }) => {
  const getPaginationItems = () => {
    const items = [];
    const pageLimit = 5; // Number of pages to display at once
    const halfPageLimit = Math.floor(pageLimit / 2);

    let startPage = Math.max(1, currentPage - halfPageLimit);
    let endPage = Math.min(totalPages, currentPage + halfPageLimit);

    if (currentPage <= halfPageLimit) {
      endPage = Math.min(totalPages, pageLimit);
    }

    if (currentPage + halfPageLimit >= totalPages) {
      startPage = Math.max(1, totalPages - pageLimit + 1);
    }

    if (startPage > 1) {
      items.push(
        <Pagination.Item key="start" onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }
      items.push(
        <Pagination.Item key="end" onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <Pagination>
      <Pagination.Prev
        onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
        disabled={currentPage === 1}
      >
        <i className="bi bi-arrow-left"></i>
      </Pagination.Prev>
      {getPaginationItems()}
      <Pagination.Next
        onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
      >
       <i className="bi bi-arrow-right"></i>
      </Pagination.Next>
    </Pagination>
  );
};

export default CustomPagination;
